(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;
		//this.throttledScrollHandler = throttle(this.onScrollHandler, 300);

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-2');
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-2');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector(".overflow-hidden-tablet")) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector('.entering-section')) {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}
		else{
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden','color-background-2');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-2');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true);
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
function playBrandVideos() {
  document.querySelectorAll('.brand-page video').forEach(function (video) {
    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.controls = false;
    video.removeAttribute('controls');

    var playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(function () {});
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', playBrandVideos, { once: true });
} else {
  playBrandVideos();
}

document.addEventListener('shopify:section:load', playBrandVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();

		this.isProductPage = true
	}

	hide() {
		super.hide(this.isProductPage);
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();		
	}

	showActiveMedia() {
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
		}
		if (activeMedia?.nodeName == 'DEFERRED-MEDIA' && activeMedia?.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mooi-set-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mooi-set-builder')) {
    customElements.define('mooi-set-builder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
        this.products = Array.from(this.querySelectorAll('[data-product]')).map(el => ({el, id: Number(el.dataset.id), price: Number(el.dataset.price), max: Number(el.dataset.max), title: el.dataset.title, quantity: 0}));
        this.busy = false;
        this.uncertain = false;
        this.formatter = new Intl.NumberFormat(this.dataset.locale, {style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code'});
        this.currencyStep = 100 / (10 ** this.formatter.resolvedOptions().maximumFractionDigits);
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || this.busy || this.uncertain) return;
          const card = button.closest('[data-product]');
          if (card) {
            const product = this.products.find(item => item.el === card);
            if (button.matches('[data-add], [data-plus]') && this.count() < 5 && product.quantity < product.max) product.quantity += 1;
            if (button.matches('[data-minus]')) product.quantity = Math.max(0, product.quantity - 1);
          } else if (button.dataset.remove) {
            const product = this.products.find(item => item.id === Number(button.dataset.remove));
            if (product) product.quantity = 0;
          } else return;
          this.querySelector('[data-error]').hidden = true;
          this.render();
        });
        this.querySelector('[data-set-form]').addEventListener('submit', event => { event.preventDefault(); this.addToCart(); });
        this.render();
      }
      count() { return this.products.reduce((count, product) => count + product.quantity, 0); }
      money(amount) { return this.formatter.format(amount / 100); }
      render() {
        const count = this.count();
        this.querySelector('[data-total-count]').textContent = '(' + count + '/5)';
        this.querySelector('[data-hint]').textContent = count === 0 ? this.messages.chooseTwo : count === 1 ? this.messages.chooseOne : count === 5 ? this.messages.maximum : this.messages.ready;
        const selected = this.products.filter(product => product.quantity > 0);
        this.products.forEach(product => {
          product.el.querySelector('[data-add]').hidden = product.quantity > 0;
          product.el.querySelector('[data-add]').disabled = this.busy || this.uncertain || product.max === 0 || count === 5;
          product.el.querySelector('[data-quantity]').hidden = product.quantity === 0;
          product.el.querySelector('[data-count]').textContent = product.quantity;
          product.el.querySelector('[data-plus]').disabled = this.busy || this.uncertain || count === 5 || product.quantity >= product.max;
          product.el.querySelector('[data-minus]').disabled = this.busy || this.uncertain;
        });
        const selection = this.querySelector('[data-selection]');
        selection.replaceChildren();
        selected.forEach(product => {
          const row = document.createElement('div'); row.className = 'mooi-set__row';
          const text = document.createElement('span'); text.textContent = product.title + ' × ' + product.quantity;
          const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.remove = product.id; remove.textContent = this.messages.remove; remove.setAttribute('aria-label', this.messages.remove + ' ' + product.title); remove.disabled = this.busy || this.uncertain;
          row.append(text, remove); selection.append(row);
        });
        const subtotal = selected.reduce((sum, product) => sum + product.price * product.quantity, 0);
        const discount = count >= 2 ? selected.reduce((sum, product) => sum + Math.round(product.price * product.quantity * .05 / this.currencyStep) * this.currencyStep, 0) : 0;
        this.querySelector('[data-subtotal]').textContent = this.money(subtotal);
        this.querySelector('[data-discount]').textContent = '−' + this.money(discount);
        this.querySelector('[data-total]').textContent = this.money(subtotal - discount);
        const submit = this.querySelector('[data-submit]');
        submit.disabled = this.busy || this.uncertain || count < 2 || count > 5;
        submit.textContent = this.busy ? this.messages.adding : this.messages.addCart;
        this.setAttribute('aria-busy', this.busy ? 'true' : 'false');
      }
      async addToCart() {
        if (this.busy || this.uncertain || this.count() < 2 || this.count() > 5) return;
        this.busy = true; this.render();
        const error = this.querySelector('[data-error]'); error.hidden = true;
        const root = this.dataset.root.replace(/\/?$/, '/');
        let submitted = false;
        try {
          const cartResponse = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}, cache: 'no-store'});
          if (!cartResponse.ok) throw new Error(this.messages.error);
          const cart = await cartResponse.json();
          const items = this.products.filter(product => product.quantity).map(product => {
            const existing = cart.items.filter(item => item.variant_id === product.id).reduce((sum, item) => sum + item.quantity, 0);
            if (product.max < 5 && product.quantity + existing > product.max) throw new Error(this.messages.stock);
            return {id: product.id, quantity: product.quantity};
          });
          submitted = true;
          const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
          if (!response.ok) { this.uncertain = true; throw new Error(this.messages.uncertain); }
          const result = await response.json();
          if (!Array.isArray(result.items)) { this.uncertain = true; throw new Error(this.messages.uncertain); }
          document.dispatchEvent(new CustomEvent('cart:updated'));
          window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          if (submitted) this.uncertain = true;
          error.textContent = this.uncertain ? this.messages.uncertain : failure.message || this.messages.error;
          error.hidden = false;
          this.querySelector('[data-cart-link]').hidden = false;
          this.busy = false; this.render();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
